import React, { useState } from 'react'
import { Contact } from 'types'
import { useCreateContact } from '../../api/aws/useCreateContact'
import { EntityAutocomplete } from 'components/ui/EntityAutocomplete'
import ContactsDialog from './ContactsDialog'

const ContactsAutocomplete = ({
  contacts = [],
  selectedContacts,
  setSelectedContacts,
  label,
  onChange,
  validationErrors,
  isLoading,
}: {
  contacts: Contact[]
  selectedContacts: Contact[]
  setSelectedContacts: React.Dispatch<React.SetStateAction<Contact[]>>
  label?: string
  onChange: (newSelectedContacts: Contact[]) => void
  validationErrors?: {
    organization: boolean
    type: boolean
    startDate: boolean
    endDate: boolean
    selectedDeal: boolean
  }
  isLoading?: boolean
}) => {
  const [dialogOpen, setDialogOpen] = useState(false)
  const [tempInput, setTempInput] = useState('')
  const { mutate: createContact } = useCreateContact()

  const handleOpenDialog = (inputValue: string) => {
    setTempInput(inputValue)
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
    setTempInput('')
  }

  const handleCreateContacts = (newValue: any) => {
    createContact(newValue, {
      onSuccess: data => {
        const newContact = { ...data, contacts_uuid: data.contacts_uuid }
        const updatedContacts = [...(selectedContacts || []), newContact]
        setSelectedContacts(updatedContacts)
        onChange(updatedContacts)
        handleCloseDialog()
      },
    })
  }

  const handleChange = (newValue: Contact | Contact[] | null) => {
    const contacts = Array.isArray(newValue) ? newValue : newValue ? [newValue] : []
    setSelectedContacts(contacts)
    onChange(contacts)
  }

  return (
    <>
      <EntityAutocomplete<Contact>
        id="contacts-autocomplete"
        options={contacts}
        value={selectedContacts || []}
        onChange={handleChange}
        getOptionLabel={contact => contact.name || ''}
        getOptionKey={contact => contact.contacts_uuid}
        label={label}
        multiple
        avatar={{
          getPhotoUrl: contact => contact.photoUrl,
          getName: contact => contact.name || '',
          bgColor: 'rgb(255, 188, 220)',
        }}
        secondaryText={{
          getText: contact => contact.email,
          fontSize: 12,
        }}
        createNew={{
          enabled: true,
          onCreateNew: handleOpenDialog,
          buttonLabel: 'Add',
        }}
        freeSolo
        disabled={validationErrors?.organization ?? false}
        loading={isLoading}
        maxTags={1}
        textFieldSx={{
          '& .MuiInputBase-root': {
            bgcolor: validationErrors?.organization ? 'background.defaultdim' : '',
          },
        }}
      />
      <ContactsDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        tempInput={tempInput}
        onSaveContact={handleCreateContacts}
      />
    </>
  )
}

export default ContactsAutocomplete
